import { render, staticRenderFns } from "./PatientAppointment.vue?vue&type=template&id=687ddaf4&"
import script from "./PatientAppointment.vue?vue&type=script&lang=js&"
export * from "./PatientAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports